<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="課程管理"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table ref="scrollarea" class="" striped hover :items="items" :fields="fields" @scrolldownend="loadTickets(true)">
        <template slot="actions" slot-scope="row">
          <b-button v-if="row.item.store_names===''" disabled size="sm" class="mr-1">
            分店未連結
          </b-button>
          <b-button size="sm" @click.stop="editPopup(row, row.index, $event.target)" class="mr-1">
            {{row.item.ticket_project_confirmed?"修改設定":"新設定"}}
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="editTicketModal"
      ref="ticketModal"
      v-model="modalShow" 
      centered
      hide-header
      hide-footer
      :static="true"
      @hide="closeCheck"
      @shown="setFocus"
    >
      <populate-form
        formTitle="課程設定"
        fkey="ts01"
        ref="editForm"
        populateOptionVar="editOptions"
        :parentVue="this"
        formDataObjVar="formData"
      />
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'TicketManage',
  components: {
  
  },
  data: function () {
    return {
      formData: {},
      editOptions: [
        {
          componentType:"span",
          akey:'span1',
          placeholder:"PI",
          col:4
        },
        {
          componentType:"text",
          akey:'product_id',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          akey:'span101',
          placeholder:"類型",
          title:"pure_paper:純紙本\ndual_reserve:紙電共存\nelectronic:電子票\npaper_non_reserve:紙本可核銷",
          col:4
        },
        {
          componentType:"text",
          akey:'prod_cond',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          akey:'span11',
          placeholder:"供應商",
          col:4
        },
        {
          componentType:"text",
          akey:'merchant_name',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          akey:'span12',
          placeholder:"對應分店",
          col:4
        },
        {
          componentType:"b-form-textarea",
          akey:'store_names',
          placeholder:"",
          col:6,
          rows:3,
          disabled:true
        },
        {
          componentType:"span",
          akey:'span2',
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          akey:'span3',
          placeholder:"課程服務時間",
          col:4
        },
        {
          componentType:"number",
          akey:'service_standard_minutes',
          placeholder:"輸入服務時間(尚未支援分開維護)",
          col:4,
        },
        {
          componentType:"span",
          akey:'span31',
          placeholder:"",
          col:4
        },
        {
          componentType:"span",
          akey:'span41',
          placeholder:"優惠生效日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_start_date',
          placeholder:"輸入優惠生效日",
          col:6,
        },
        {
          componentType:"span",
          akey:'span42',
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          akey:'span51',
          placeholder:"優惠結束日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_end_date',
          placeholder:"輸入優惠結束日",
          col:6,
        },
        {
          componentType:"span",
          akey:'span52',
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          akey:'span61',
          placeholder:"延長結束日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_extend_date',
          placeholder:"輸入優惠延長結束日",
          col:6,
        },
        {
          componentType:"span",
          akey:'span62',
          placeholder:"",
          col:2
        },
        {
          componentType:"b-button",
          akey:'btnCancel',
          placeholder:"取消",
          col:6,
          execCallback:this.modalCancel
        },
        {
          componentType:"b-button",
          akey:'btnOK',
          placeholder:"保存",
          col:6,
          hide:(this.$bus.session&&['support','support_mgr'].includes(this.$bus.session.role_type)),
          execCallback:this.modalOK,
          waitClick:true,
        },
      ],
      filterData: {},
      filterOptions: [
        {
          componentType:'vue-single-select',
          optionVar:'Merchants',
          asyncFetchCB: this.loadMerchantByKeyword,
          defaultValue:null,
          akey:'SelectedMerchantItem',
          optionLabel:'merchant_full_name',
          col:9,
          placeholder:'選擇商家(輸入至少一個字的商家名稱關鍵字或SU編號帶出選項,按Esc可清除全部關鍵字)',
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'ticket_project_name',
          col:3,
          placeholder:'關鍵字查詢(名稱與PI)',
          execCallback:this.loadTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'QueryStartDate',
          col:3,
          placeholder:'篩選優惠到期日起',
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'QueryEndDate',
          col:3,
          placeholder:'篩選優惠到期日迄',
        },
        {
          componentType:'b-form-select',
          defaultValue:'all',
          akey:'Iconfirmed',
          dataOptions:[{text:'全部設定狀態',value:'all'},{text:'僅未設定',value:'pending'},{text:'僅已設定',value:'confirmed'}],
          col:3,
        },
        {
          componentType:'span',
          akey:'span1',
          col:1,
          placeholder:''
        },
        {
          componentType:'b-button',
          akey:'btnQry',
          col:2,
          placeholder:'查詢',
          execCallback: this.loadTickets
        },
      ],
      showFilter: true,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      QueryStartDate: null,
      QueryEndDate: null,
      modalShow: false,
      editingRow: {},
      editingIndex: 0,
      items: [],
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      isLoading:false,
      fields: [
        {
          key: 'product_id',
          label: '票券序號',
          sortable: false
        },
        {
          key: 'ticket_project_name',
          label: '課程名稱',
          sortable: false
        },
        {
          key: 'service_items[0].service_standard_minutes',
          label: '課程長度',
          sortable: false
        },
        {
          key: 'sale_price',
          label: '售價',
          sortable: true
        },
        {
          key:'wait_use_count',
          label:'未用張數',
        },
        {
          key: 'actions',
          label: '功能'
        }
      ]
    }
  },
  methods: {
    handleScroll(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    },
    filterChanged (upd) {
      if (upd.key === 'SelectedMerchantItem') {
        if (upd.val) {
          this.SelectedMerchantId = upd.val.merchant_id
        }
        else {
          this.SelectedMerchantId = null
        }
      }
      if (['SelectedMerchantItem','Iconfirmed'].includes(upd.key)) {
        setTimeout(() => {
          this.loadTickets()
        }, 50);
      }
    },
    loadMerchantByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Merchants = data.data.matched_merchant_list
      },this)
    },
    loadTickets: function (append = false) {
      if (append === true) {
        if (!this.hasMore || this.isLoading) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'get_ticket_project_list',
        'merchant_id': this.SelectedMerchantId?this.SelectedMerchantId:0,
        'confirmed':this.filterData.Iconfirmed,
        'keyword':this.filterData.ticket_project_name,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }
      if (this.filterData.QueryStartDate) {
        rptParam.search_start_date = this.filterData.QueryStartDate
      }
      if (this.filterData.QueryEndDate) {
        rptParam.search_end_date = this.filterData.QueryEndDate
      }
      this.isLoading = true
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        if (vm.pageNumber === 1) {
          vm.items = data.data.ticket_project_list
        }
        else {
          vm.items = vm.items.concat(data.data.ticket_project_list)
        }
        if (data.data.total <= vm.items.length) {
          vm.hasMore = false
        }
        vm.isLoading = false
      }, this)
    },
    editPopup: function (row, index) {
      row.item.service_standard_minutes = row.item.service_items.length===1?row.item.service_items[0].service_standard_minutes:''
      row.item.service_assert_minutes = row.item.service_items.length===1?row.item.service_items[0].service_assert_minutes:''
      this.formData = this.CpObj(row.item)
      this.editingIndex = index
      this.modalShow = true
    },
    closeCheck: function (evt) {
      if (this.modalShow) {
        evt.preventDefault()
      }
    },
    setFocus: function () {
      if (this.formData.service_standard_minutes == '') {
        this.$refs.editForm.setFocus('service_standard_minutes')
      }
      else {
        this.$refs.editForm.setFocus('btnCancel')
      }
    },
    modalOK: function (doneCB) {
      if (!this.formData.service_standard_minutes || !this.formData.project_start_date || !this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("請檢查必填欄位")
        doneCB()
        return
      }
      if (this.formData.project_extend_date && this.formData.project_extend_date < this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("延長優惠日期不得早於原優惠到期日")
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'setup_merchant_ticket',
        'ticket_project_id': this.formData.ticket_project_id,
        'service_standard_minutes': this.formData.service_standard_minutes,
        'service_assert_minutes': this.formData.service_assert_minutes,
        'service_quota': 1,
        'usage_limit_per_user': 1,
        'project_start_date': this.formData.project_start_date,
        'project_end_date': this.formData.project_end_date,
        'project_extend_date': this.formData.project_extend_date?this.formData.project_extend_date:''
      }
      //service_assert_minutes只有create時才傳input的值就好,edit時帶舊值
      if (!this.formData.ticket_project_confirmed) {
        Param.service_assert_minutes = this.formData.service_standard_minutes
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$refs.editForm.triggerAlert(data.msg)
            doneCB()
            return
          }
          if (vm.formData.service_items.length > 0) {
            vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
            vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
          }
          else {
            vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
          }
          // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
          vm.formData.ticket_project_confirmed = 1
          vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
          vm.items = vm.CpObj(vm.items)
          doneCB()
          vm.modalShow = false
          vm.$bus.fnShowInfo('設定完成')
      }, this)
    },
    modalCancel: function () {
      this.modalShow = false
    },
  },
  created() {
    
  },
  mounted() {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.$refs.editForm.initDefault()
    }, 100);
    this.loadTickets()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 65vh;
  overflow-y: scroll;
  border-style: inset;
}

</style>
